import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import tabsContent from "../tabs-content/tabs-content.vue";
import i18n from "@/config/i18n";
let PiSysContent = class PiSysContent extends Vue {
    constructor() {
        super(...arguments);
        this.win = window;
        this.title = "";
    }
    tabChange(val) {
        this.$emit("tabChange", val);
    }
    goBackClick() {
        if (this.goBackUrl != "") {
            this.$common.goBack(this.$route, this.goBackUrl);
        }
        else {
            this.$common.goBack(this.$route);
        }
    }
    mounted() {
        let title = "";
        let meta = this.$route.meta || {};
        if (meta.nameKey) {
            title = i18n.t("childMenuTitle." + meta.nameKey) + "";
        }
        else {
            title = meta.menuData
                ? i18n.locale == "en-US"
                    ? meta.menuData.englishName
                    : meta.menuData.moduleName
                : "";
        }
        this.title = title;
    }
};
__decorate([
    Prop({ default: "" })
], PiSysContent.prototype, "pageTitle", void 0);
__decorate([
    Prop({ default: "" })
], PiSysContent.prototype, "goBackUrl", void 0);
__decorate([
    Prop({ default: false })
], PiSysContent.prototype, "pageTitleShow", void 0);
__decorate([
    Prop({ default: true })
], PiSysContent.prototype, "white", void 0);
__decorate([
    Prop({ default: true })
], PiSysContent.prototype, "flexContent", void 0);
__decorate([
    Prop({ default: false })
], PiSysContent.prototype, "goBack", void 0);
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiSysContent.prototype, "tabsList", void 0);
__decorate([
    Prop({ default: "" })
], PiSysContent.prototype, "tabsActive", void 0);
PiSysContent = __decorate([
    Component({
        components: {
            "pi-tabs-content": tabsContent,
        },
    })
], PiSysContent);
export default PiSysContent;
